import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import styles from './sellProduct.module.css';
import {
    getNewPlaces,
    getNewProductCategories,
    getNewProducts,
    getOrders,
    createOrder,
    getOrder,
    updateOrderSends,
    deleteOrder,
    getOrdersHistory,
    getMissingDays
} from "../../apiForNewProducts.js";
import { Modal, Button, Form } from "react-bootstrap";

function SellProduct() {
    const [currentDate, setCurrentDate] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    });
    const [isHiddenCalendar, setIsHiddenCalendar] = useState(true);
    const [currentPlace, setCurrentPlace] = useState(null);
    const [places, setPlaces] = useState([]);
    const [productCategories, setProductCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [jwt] = useState(localStorage.getItem('jwtToken'));
    const [isLoad, setIsLoad] = useState(false);

    const [orders, setOrders] = useState([]);
    const [currentOrder, setCurrentOrder] = useState(null);
    const [orderSends, setOrderSends] = useState([]);

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newOrderName, setNewOrderName] = useState("");

    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [historyOrders, setHistoryOrders] = useState([]);
    const [historyPage, setHistoryPage] = useState(1);
    const [historyTotalPages, setHistoryTotalPages] = useState(1);

    const [missingDays, setMissingDays] = useState([]);
    const [showMissingWarning, setShowMissingWarning] = useState(false);

    useEffect(() => {
        loadMissingDays();
    }, [currentDate.getFullYear(), currentDate.getMonth()]); // зависит от года и месяца

    async function loadMissingDays() {
        try {
            const data = await getMissingDays(currentDate.getFullYear(), currentDate.getMonth() + 1, jwt);
            setMissingDays(data.missingDays);
            setShowMissingWarning(data.missingDays.length > 0);
        } catch (error) {
            console.error("Ошибка загрузки пропущенных дней", error);
        }
    }

    const handleDateChange = (date) => {
        setCurrentDate(date);
        setIsHiddenCalendar(true);
    };

    useEffect(() => {
        async function loadBaseData() {
            const responsePlaces = await getNewPlaces(jwt);
            if (responsePlaces?.length) {
                setPlaces(responsePlaces);
                setCurrentPlace(responsePlaces[0]);
            }
            const categories = await getNewProductCategories(jwt, true);
            setProductCategories(categories);
            const prods = await getNewProducts(jwt);
            setProducts(prods);
        }
        loadBaseData();
    }, []);

    useEffect(() => {
        if (!currentPlace) return;
        setCurrentOrder(null);
        setOrderSends([]);
        loadOrders();
    }, [currentDate, currentPlace]);

    async function loadOrders() {
        setIsLoad(true);
        try {
            const ordersList = await getOrders(currentDate, currentPlace.id, jwt);
            setOrders(ordersList);
            if (ordersList.length > 0) {
                // По умолчанию выбираем первый заказ
                await loadOrder(ordersList[0].id);
            } else {
                setCurrentOrder(null);
                setOrderSends([]);
            }
        } catch (error) {
            console.error("Ошибка загрузки заказов", error);
        } finally {
            setIsLoad(false);
        }
    }

    async function loadOrder(orderId) {
        setIsLoad(true);
        try {
            const order = await getOrder(orderId, jwt);
            setCurrentOrder(order);
            // Преобразуем отправки в формат, понятный для отображения по категориям
            const sendsByCategory = buildSendsByCategory(order.sends);
            setOrderSends(sendsByCategory);
        } catch (error) {
            console.error("Ошибка загрузки заказа", error);
        } finally {
            setIsLoad(false);
        }
    }

    function buildSendsByCategory(sends) {
        const sendsMap = new Map(sends.map(s => [s.productId, s]));
        const result = [];

        // Фильтрация категорий (поле newProductPlaceId)
        const filteredCategories = productCategories.filter(cat =>
            !cat.places?.length || cat.places.some(p => p.newProductPlaceId === currentPlace.id)
        ).sort((a, b) => {
            if (a.id === 23) return 1;
            if (b.id === 23) return -1;
            return a.priority - b.priority;
        });

        // Фильтрация продуктов (поле productPlaceId)
        const filteredProducts = products.filter(product => {
            if (!product.places || product.places.length === 0) {
                return false;
            }
            return product.places.some(p => p.productPlaceId === currentPlace.id);
        });

        // Группировка по категориям
        filteredCategories.forEach(cat => {
            const catProducts = filteredProducts
                .filter(p => p.categoryId === cat.id)
                .sort((a, b) => a.priority - b.priority);
            const catSends = catProducts.map(p => ({
                productId: p.id,
                productName: p.name,
                value: sendsMap.get(p.id)?.value || 0
            }));
            if (catSends.length) {
                result.push({ id: cat.id, name: cat.name, sends: catSends });
            }
        });

        // Продукты без категории
        const noCatProducts = filteredProducts
            .filter(p => p.categoryId == null)
            .sort((a, b) => a.priority - b.priority);
        const noCatSends = noCatProducts.map(p => ({
            productId: p.id,
            productName: p.name,
            value: sendsMap.get(p.id)?.value || 0
        }));
        if (noCatSends.length) {
            result.push({ id: null, name: "Без категории", sends: noCatSends });
        }

        return result;
    }
    // Обработчик изменения значения в поле ввода
    function handleValueChange(categoryIndex, productIndex, newValue) {
        const updated = [...orderSends];
        updated[categoryIndex].sends[productIndex].value = Number(newValue) || 0;
        setOrderSends(updated);
    }

    // Сохранение всех отправок текущего заказа
    async function handleSave() {
        if (!currentOrder) return;
        setIsLoad(true);
        try {
            // Преобразуем orderSends в плоский массив { productId, value }
            const sendsArray = [];
            orderSends.forEach(cat => {
                cat.sends.forEach(item => {
                    sendsArray.push({ productId: item.productId, value: item.value });
                });
            });
            await updateOrderSends(currentOrder.id, sendsArray, jwt);
            alert("Сохранено");
        } catch (error) {
            console.error("Ошибка сохранения", error);
        } finally {
            setIsLoad(false);
        }
    }

    // Создание нового заказа
    async function handleCreateOrder() {
        if (!newOrderName.trim()) return;
        setIsLoad(true);
        try {
            const newOrder = await createOrder(newOrderName, currentDate, currentPlace.id, jwt);
            setShowCreateModal(false);
            setNewOrderName("");
            await loadOrders();
        } catch (error) {
            console.error("Ошибка создания заказа", error);
        } finally {
            setIsLoad(false);
        }
    }

    // Удаление заказа
    async function handleDeleteOrder() {
        if (!currentOrder || !window.confirm("Удалить заказ?")) return;
        setIsLoad(true);
        try {
            await deleteOrder(currentOrder.id, jwt);
            await loadOrders();
        } catch (error) {
            console.error("Ошибка удаления", error);
        } finally {
            setIsLoad(false);
        }
    }

    // Просмотр истории
    async function openHistory() {
        setHistoryPage(1);
        setShowHistoryModal(true);
        await loadHistoryPage(1);
    }

    async function loadHistoryPage(page) {
        setIsLoad(true);
        try {
            const result = await getOrdersHistory(jwt, page);
            setHistoryOrders(result.items);
            setHistoryTotalPages(result.totalPages);
            setHistoryPage(page);
        } catch (error) {
            console.error("Ошибка загрузки истории", error);
        } finally {
            setIsLoad(false);
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* Шапка с датой и платформами */}
                <button onClick={() => setIsHiddenCalendar(!isHiddenCalendar)} className={styles.date}>
                    {currentDate.toLocaleDateString()}
                </button>
                <div className={styles.panelButtons}>
                    {places.map(p => (
                        <button
                            key={p.id}
                            className={p.id === currentPlace?.id ? styles.currentPlaceButton : styles.placeButton}
                            onClick={() => setCurrentPlace(p)}
                        >
                            {p.name}
                        </button>
                    ))}
                </div>

                {/* Блок выбора заказа */}
                <div className={styles.orderSelector}>
                    <select
                        value={currentOrder?.id || ""}
                        onChange={(e) => loadOrder(Number(e.target.value))}
                        className={styles.orderSelect}
                    >
                        <option value="">-- Выберите заказ --</option>
                        {orders.map(o => (
                            <option key={o.id} value={o.id}>{o.name}</option>
                        ))}
                    </select>
                    <button onClick={() => setShowCreateModal(true)} className={styles.createOrderButton}>
                        + Новый заказ
                    </button>
                    <button onClick={openHistory} className={styles.historyButton}>
                        История
                    </button>
                    {currentOrder && (
                        <button onClick={handleDeleteOrder} className={styles.deleteOrderButton}>
                            Удалить заказ
                        </button>
                    )}
                </div>

                {/* Форма продуктов (если выбран заказ) */}
                {currentOrder && (
                    <>
                        <div className={styles.productsSend}>
                            {orderSends.length > 0 ? orderSends.map((category, catIndex) => (
                                <div key={category.id} className={styles.categoryItem}>
                                    <div className={styles.titleCategory}>{category.name}</div>
                                    <div className={styles.categorySends}>
                                        {category.sends.map((item, prodIndex) => (
                                            <div key={item.productId} className={styles.item}>
                                                <div className={styles.item_text}>{item.productName}</div>
                                                <input
                                                    type="number"
                                                    className={styles.item_input}
                                                    value={item.value}
                                                    onChange={(e) => handleValueChange(catIndex, prodIndex, e.target.value)}
                                                    min="0"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )) : <div className={styles.emptyMessage}>Нет продуктов для этой платформы</div>}
                        </div>
                        <button
                            disabled={isLoad}
                            className={styles.save_button}
                            onClick={handleSave}
                        >
                            Сохранить
                        </button>
                    </>
                )}
            </div>

            {/* Календарь (как раньше) */}
            <div
                onClick={(e) => { if (e.target.className.includes('calendarBody')) setIsHiddenCalendar(true); }}
                className={styles.calendarBody}
                hidden={isHiddenCalendar}
            >
                <Calendar
                    locale="ru-RU"
                    onChange={(date) => { setCurrentDate(date); setIsHiddenCalendar(true); }}
                    value={currentDate}
                />
            </div>

            {/* Модалка создания заказа */}
            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Новый заказ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Название заказа</Form.Label>
                        <Form.Control
                            type="text"
                            value={newOrderName}
                            onChange={(e) => setNewOrderName(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>Отмена</Button>
                    <Button variant="primary" onClick={handleCreateOrder} disabled={!newOrderName.trim()}>
                        Создать
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Модалка истории заказов */}
            <Modal show={showHistoryModal} onHide={() => setShowHistoryModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>История заказов</Modal.Title>
                </Modal.Header>
                {showMissingWarning && (
                    <div className={styles.missingWarning}>
                        ⚠️ В этом месяце нет заказов в следующие дни: {missingDays.join(', ')}
                    </div>
                )}
                <Modal.Body>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Дата заказа</th>
                                <th>Название</th>
                                <th>Платформа</th>
                                <th>Менеджер</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historyOrders.map(o => (
                                <tr key={o.id}>
                                    <td>{new Date(o.orderDate).toLocaleDateString()}</td>
                                    <td>{o.name}</td>
                                    <td>{o.placeName}</td>
                                    <td>{o.managerName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal.Body>
                {historyTotalPages > 1 && (
                    <Modal.Footer>
                        <Button
                            variant="outline-secondary"
                            disabled={historyPage <= 1 || isLoad}
                            onClick={() => loadHistoryPage(historyPage - 1)}
                        >
                            ← Назад
                        </Button>
                        <span className="mx-3">{historyPage} / {historyTotalPages}</span>
                        <Button
                            variant="outline-secondary"
                            disabled={historyPage >= historyTotalPages || isLoad}
                            onClick={() => loadHistoryPage(historyPage + 1)}
                        >
                            Вперёд →
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </div>
    );
}

export default SellProduct;